import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";

import Header from "../inc/Header";
import ladieschain33_210gm from "../images/Ladies chain 33.210gm.jpg";
import ladieschain33_260gm from "../images/Ladies chain 33.260gm.jpg";
import Ladieschain40_630gm from "../images/Ladies chain 40.630gm.jpg";
import ladieschain43_310gm from "../images/Ladies chain 43.310gm.jpg";

import ladieschain45_590gm from "../images/Ladies Chain 45.590gm.jpg";
import ladieschain61_140gm from "../images/Ladies chain 61.140gm.jpg";





import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function LadiesCpage() {
    return (
        <div>

            <Header />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="maroon" />
            <div className='colorbacklockt'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Ladies Chain</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
<div className='solidchur'>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={ladieschain33_210gm} className="card-img-top" alt="ladieschain33_210gm" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Ladies Chain </h5>
                                                <p className="card-text">Weight: 33.210gm</p>
                                                <p className="card-text mb-2">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={ladieschain33_260gm} className="card-img-top" alt="ladieschain33.260gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Ladies Chain</h5>
                                                <p className="card-text">Weight: 33.260gm</p>
                                                <p className="card-text mb-2">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Ladieschain40_630gm} className="card-img-top" alt="Ladieschain40.630gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Ladies Chain</h5>
                                                <p className="card-text">Weight: 40.630gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={ladieschain43_310gm} className="card-img-top" alt="ladieschain43.310gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Ladies Chain                                   </h5>
                                                <p className="card-text">Weight: 43.310gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

<div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={ladieschain45_590gm} className="card-img-top" alt="ladieschain45.590gm" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Ladies Chain </h5>
                                                <p className="card-text">Weight: 45.590gm</p>
                                                <p className="card-text mb-2">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={ladieschain61_140gm} className="card-img-top" alt="ladieschain61.140gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Ladies Chain</h5>
                                                <p className="card-text">Weight: 61.140gm</p>
                                                <p className="card-text mb-2">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        

                    </div>
                </div>
            </div>



           




         <br />

            <br />
            </div>
           
        </div>
    )
}

export default LadiesCpage